import React from 'react';

import classNames from 'classnames/bind';
import styles from './SpriteIcon.scss';
const cx = classNames.bind(styles);

const SpriteIcon = React.memo(({ name, style = {}, className = [] }) => {
  return (
    <span
      className={cx('sprite-' + name, 'sprite-icon', ...className)}
      style={style}
    />
  );
});

export default SpriteIcon;
